import { WidgetIconsTypes } from '@app/components/ui/icons/widget-icons/icons.type';

export const widgetIconsMap: Record<number, WidgetIconsTypes> = {
  1: 'WidgetArchiveBox',
  2: 'WidgetArrowDown',
  3: 'WidgetArrowDownRight',
  4: 'WidgetArrowLeft',
  5: 'WidgetArrowRight',
  6: 'WidgetArrowUp',
  7: 'WidgetArrowUpArrowDown',
  8: 'WidgetArrowUpRight',
  9: 'WidgetBell',
  10: 'WidgetBolt',
  11: 'WidgetBoltFill',
  12: 'WidgetBubbleRight',
  13: 'WidgetCalendar',
  14: 'WidgetCamera',
  15: 'WidgetCart',
  16: 'WidgetChartBar',
  17: 'WidgetChartBarH',
  18: 'WidgetChartLine',
  19: 'WidgetChartPie',
  20: 'WidgetChartXYAxis',
  21: 'WidgetCheckmark',
  22: 'WidgetCheckmarkCircle',
  23: 'WidgetChevronDown',
  24: 'WidgetChevronLeft',
  25: 'WidgetChevronRight',
  26: 'WidgetChevronUp',
  27: 'WidgetCircle',
  28: 'WidgetCircleFill',
  29: 'WidgetClipboard',
  30: 'WidgetClock',
  31: 'WidgetCloud',
  32: 'WidgetCreditCard',
  33: 'WidgetDiamond',
  34: 'WidgetDisplay',
  35: 'WidgetDoc',
  36: 'WidgetDollarSignCircle',
  37: 'WidgetDrop',
  38: 'WidgetEnvelope',
  39: 'WidgetExclamation',
  40: 'WidgetEye',
  41: 'WidgetEyeSlash',
  42: 'WidgetFlag',
  43: 'WidgetFlagFill',
  44: 'WidgetFlame',
  45: 'WidgetFolder',
  46: 'WidgetGear',
  47: 'WidgetGift',
  48: 'WidgetGlobe',
  49: 'WidgetHeart',
  50: 'WidgetHeartFill',
  51: 'WidgetHouse',
  52: 'WidgetInfoCircle',
  53: 'WidgetKey',
  54: 'WidgetLeaf',
  55: 'WidgetLink',
  56: 'WidgetLocation',
  57: 'WidgetLock',
  58: 'WidgetLockOpen',
  59: 'WidgetMagnifyingGlass',
  60: 'WidgetMic',
  61: 'WidgetMinusCircle',
  62: 'WidgetMoon',
  63: 'WidgetNumber',
  64: 'WidgetPaperPlane',
  65: 'WidgetPause',
  66: 'WidgetPerson',
  67: 'WidgetPerson2',
  68: 'WidgetPersonCropCircle',
  69: 'WidgetPhone',
  70: 'WidgetPlay',
  71: 'WidgetPlayFill',
  72: 'WidgetPlusCircle',
  73: 'WidgetQuestionmark',
  74: 'WidgetShield',
  75: 'WidgetShieldCheck',
  76: 'WidgetSnowflake',
  77: 'WidgetSpeakerWave2',
  78: 'WidgetSquare',
  79: 'WidgetStar',
  80: 'WidgetStarFill',
  81: 'WidgetStopwatch',
  82: 'WidgetSunMax',
  83: 'WidgetTag',
  84: 'WidgetTimer',
  85: 'WidgetTray',
  86: 'WidgetTriangle',
  87: 'WidgetWaveform',
  88: 'WidgetXmark',
  89: 'WidgetXmarkCircle',
};
